<template>
    <div>
      <b-alert v-if="findingLocation" show variant="info">{{ $t('sandoz.geolocation_loading_msg') }}</b-alert>
      <b-alert v-else-if="!findingLocation && error" show variant="warning">{{ $t('sandoz.geolocation_error_msg', { message: error }) }}</b-alert>
      <o-table v-if="!findingLocation" ref="tableList" :enable-new="false" :title="$t('sandoz.verifications')"
               :url="'/api/verifications-new/contracts?lat=' + latitude + '&long=' + longitude"
               default-sort-by="distance" :full-row-click="true" :row-click-function="true" @row-click="loadVerifications"
               :highlight-row="isResponsibleRep">
        <template slot="filter">
          <o-filter :default-filter="defaultFilter" :filter-cacheable="true"
                    v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
            <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
            <o-filter-select :items="verificationStatus" :title="$t('sandoz.status')" column="verification_status">
            </o-filter-select>
            <o-filter-checkbox :items="salesPersons" :title="$t('sandoz.responsible_sales_person')" column="sales_person" classes="w260" :floatLeft="false">
            </o-filter-checkbox>
            <o-filter-text :title="$t('sandoz.name')" column="name"></o-filter-text>
            <o-filter-text :title="$t('sandoz.parent_name')" column="parent_name"></o-filter-text>
            <o-filter-text :title="$t('sandoz.address')" column="address" :placeholder="$t('sandoz.street_zip_city')"></o-filter-text>
            <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
            <o-filter-select :items="delivery" :title="$t('sandoz.delivery')" column="delivery"></o-filter-select>
            <o-filter-select :items="types" :title="$t('sandoz.type')" column="contract_type">
            </o-filter-select>
            <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
          </o-filter>
        </template>
        <template slot="head">
          <o-table-header column="name">{{ $t('sandoz.name') }}</o-table-header>
          <o-table-header column="address">{{ $t('sandoz.address') }}</o-table-header>
          <o-table-header column="distance">{{ $t('sandoz.distance') }}</o-table-header>
          <o-table-header column="date" class="d-none d-sm-table-cell">{{ $t('sandoz.dates') }}</o-table-header>
          <o-table-header :sortable="false" class="d-none d-sm-table-cell">{{ $t('sandoz.status') }}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
          <td class="text-pre">{{ props.item.name }}
            <span class="master-name" v-if="checkMasterName(props.item.name, props.item.group_master_company_name).length > 0">{{ checkMasterName(props.item.name, props.item.group_master_company_name)[0]}}</span>
          </td>
          <td class="text-pre">{{ props.item.address }}</td>
          <td>{{ props.item.distance | formatDistance }}</td>
          <td class="d-none d-sm-table-cell mw-270">
            <template v-if="props.item.dates">
              <template v-for="(date, index) in props.item.dates">
                <span :class="{'badge badge-danger': date.valid_to == today.toJSON().slice(0, 10)}">{{date.valid_from|formatDate}} - {{date.valid_to|formatDate}}</span>
                <br v-if="props.item.dates.length > 0 && props.item.dates.length !== index + 1">
              </template>
            </template>
          </td>
          <td class="d-none d-sm-table-cell">
            <span class="badge badge-secondary mr-1" :title="$t('sandoz.title_total_pending_lines')" :class="{'bg-opaque': props.item.pending === 0}">
              {{ props.item.pending }}
            </span>
            <span class="badge badge-success mr-1" :title="$t('sandoz.title_total_approved_lines')" :class="{'bg-opaque': props.item.verified === 0}">
              {{ props.item.verified }}
            </span>
            <span class="badge badge-danger mr-1" :title="$t('sandoz.title_total_failed_lines')" :class="{'bg-opaque': props.item.failed === 0}">
              {{ props.item.failed }}
            </span>
            <span class="badge badge-warning" :title="$t('sandoz.title_not_delivered_lines')" :class="{'bg-opaque': props.item.upcoming === 0}">
              {{ props.item.upcoming }}
            </span>
          </td>
        </template>
        <template slot="body-controls" slot-scope="props">
          <td class="text-right">
            <!-- <b-badge variant="info" v-if="checkMultipleContract(props.item.group_contract_type)">Kam</b-badge> -->
            <router-link :to="{ name: 'verifications.new_verification_detail', params: { id: props.item.customer_external_id, 'year': props.item.contract_year, 'kam': props.item.is_kam, 'address': props.item.group_address_id }}" class="btn btn-sm btn-primary">
              <fa icon="arrow-right"/>
            </router-link>
          </td>
        </template>
      </o-table>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import { contractYears, getCurrentYear } from '../../utils/contractYear'
  
  export default {
    data: () => ({
      findingLocation: false,
      latitude: null,
      longitude: null,
      error: null,
      years: [],
      defaultFilter: [],
      verificationStatus: [],
      delivery: [],
      salesPersons: [],
      types: [],
      lastAddress: null,
      today: new Date()
    }),
    created () {
      this.getGeoLocation()
  
      this.years = contractYears()
  
      this.verificationStatus = [
        { value: 'pending', text: this.$i18n.t('sandoz.has_pending_lines') },
        { value: 'verified', text: this.$i18n.t('sandoz.has_verified_lines') },
        { value: 'failed', text: this.$i18n.t('sandoz.has_failed_lines') }
      ]
  
      this.getContractSalesPerson()
  
      this.delivery = [
        { value: 'yearly', text: this.$i18n.t('sandoz.yearly') },
        { value: 'q1', text: this.$i18n.t('sandoz.quarter1') },
        { value: 'q2', text: this.$i18n.t('sandoz.quarter2') },
        { value: 'q3', text: this.$i18n.t('sandoz.quarter3') },
        { value: 'q4', text: this.$i18n.t('sandoz.quarter4') }
      ]
  
      this.types = [
        { value: 'kam', text: this.$i18n.t('sandoz.kam') },
        { value: 'others', text: this.$i18n.t('sandoz.icepeak_or_edu') }
      ]
  
      let userNames = this.user.name
      let users = []
  
      users.push(this.user.name)
  
      // set predecessors by default
      this.user.predecessors.forEach(item => {
        userNames += ',' + item
        users.push(item)
      })
  
      this.defaultFilter = [
        {
          column: 'contract_year',
          displayValue: getCurrentYear(),
          title: this.$i18n.t('sandoz.contract_year'),
          value: getCurrentYear()
        }, 
        {
           column: 'verification_status',
           displayValue: this.$i18n.t('sandoz.has_pending_lines'),
           title: this.$i18n.t('sandoz.status'),
           value: 'pending'
        },
        {
          column: 'sales_person',
          displayValue: userNames,
          title: this.$i18n.t('sandoz.responsible_sales_person'),
          value: users
        },
      ]
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
    methods: {
      getGeoLocation () {
        // this allows us to open the verification list with ?debug at the end of the URL
        // even on a local server with http:// geoLocation would otherwise only be available
        // if we are using https. With this option we can get past the geolcation
        if ('debug' in this.$route.query) {
          this.latitude = 42
          this.longitude = 7
          this.error = null
          this.findingLocation = false
          return
        }
  
        if (!('geolocation' in navigator)) {
          this.error = 'Geolocation is not supported by your browser, list unsorted'
          this.latitude = null
          this.longitude = null
          this.findingLocation = false
          return
        }
        this.findingLocation = true
  
        navigator.geolocation.getCurrentPosition(position => {
          if (position.coords === undefined) {
            this.error = 'Geolocation service failed, list unsorted'
            this.latitude = null
            this.longitude = null
          } else {
            this.latitude = position.coords.latitude
            this.longitude = position.coords.longitude
            this.error = null
          }
          this.findingLocation = false
        }, error => {
          if (error.code === 1) {
            this.error = 'Geolocation blocked, list unsorted'
          } else {
            this.error = error.message
          }
          this.latitude = null
          this.longitude = null
          this.findingLocation = false
        }, {
          // enableHighAccuracy: true,
          // timeout: 5000,
          // maximumAge: 0
        })
      },
      getContractSalesPerson () {
        var self = this
        self.salesPersons.push({ value: 'Gebiet Vakant', text: 'Vakant' })
        axios.get('/api/verifications/contract_sales_persons').then((response) => {
          if (response.data.length) {
            response.data.forEach(function (person) {
              self.salesPersons.push({ value: person, text: person })
            })
          }
        }).catch((error) => {
          console.error(error)
        })
      },
      loadVerifications: function (item) {
        this.$router.push(
          { name: 'verifications.new_verification_detail', params: { id: item.customer_external_id, 'year': item.contract_year, 'kam': item.is_kam, 'address': item.group_address_id}}
        )
      },
      isResponsibleRep: function (item) {
        if (Object.keys(item).includes('is_responsible_rep')) {
          if (item.is_responsible_rep && item.is_responsible_rep > 0) {
            return true
          }
        }
        return false
      },
      checkMultipleContract(types) {
        var typesArray = types.split(',');
        const kamFound = typesArray.some(str => str.includes('KAM_'));
        if(typesArray.length > 1 && kamFound === true) {
          return true
        }
        return false
      },
      checkMasterName(name, group_master_name) {
        var group_master_company_name = group_master_name.split(',')

        var fil_group_company = group_master_company_name.filter(company => {
            return company !== name
        })

        return fil_group_company
      }
    }
  }
  </script>
  
  <style scoped>
  .badge {
    cursor: default !important;
  }
  .master-name {
    color: gray;
    font-size: 70%;
    font-style: italic;
  }
  .mw-270 {
    max-width: 270px;
  }
  
  </style>
  